// Display helpers for BCP-47 locale tags shipped as .po files (en, zh, es-MX, es-PA...).
// Each language is named in itself (its autonym) so pickers stay readable
// whatever language the UI is currently in.

// Intl.DisplayNames renders regional variants as "español (Panamá)". Flatten
// the parentheses so the tag suffix doesn't produce "español (Panamá) (es-PA)".
const flattenRegion = (name) => name.replace(/\s*\(([^()]*)\)\s*$/, " $1");

export const languageAutonym = (tag) => {
	try {
		const name = new Intl.DisplayNames([tag], { type: "language" }).of(tag);
		return name && name !== tag ? flattenRegion(name) : tag;
	} catch {
		return tag;
	}
};

export const localeLabel = (tag) => {
	const name = languageAutonym(tag);
	return name === tag ? tag : `${name} (${tag})`;
};
